import PropTypes from "prop-types"
import classnames from "classnames"
import alertIconRaw from "images/icons/alert_ember.svg?raw"
import parse from "html-react-parser"

import styles from "./hint_pill.module.scss"

// The DSL Hint pill (node 562:11923); only the glyph's tint tells a warning from an error.
export default function HintPill({ tone = "error", variant = "on-dark", children }) {
  return (
    <span
      className={classnames(styles.pill, {
        [styles.warning]: tone === "warning",
        [styles[variant]]: variant !== "on-dark",
      })}
    >
      <span className={styles.icon}>{parse(alertIconRaw)}</span>
      <span>{children}</span>
    </span>
  )
}

HintPill.propTypes = {
  tone: PropTypes.oneOf(["error", "warning"]),
  variant: PropTypes.oneOf(["on-dark", "on-light", "on-black"]),
  children: PropTypes.node.isRequired,
}
